import ApiClient from '@/api/ApiClient';

const client = new ApiClient('agency/signatureBalance');

class SignatureBalanceApiAgency {

	static getCurrentSignature () {
		return client.get<ICurrentSignatureBalanceModel[]>('current');
	}

	static orderSignature (mailOrderSignatureBalanceParameters: IMailOrderSignatureBalanceModel) {
		return client.post<void>('order', mailOrderSignatureBalanceParameters);
	}

	static updateInterlocutor (signatureBalance: IUpdateSignatureBalanceInterlocutorModel) {
		return client.put<void>('interlocutor', signatureBalance);
	}
}

export default SignatureBalanceApiAgency;
